import { Box, Text, Stack, Column, Columns, Link } from 'braid-design-system';

import { CopyButton } from './CopyButton';

import * as styles from './ManageUrl.css';

export const ManageUrl = ({
  profileUrl,
  profileDisplayUrl,
  isActive,
}: {
  profileUrl: string;
  profileDisplayUrl: string;
  isActive: boolean;
}) => {
  const urlTone = isActive ? 'neutral' : 'secondary';

  const DisplayUrl = ({ clickable }: { clickable?: boolean }) => (
    <Box
      component="span"
      background="neutralLight"
      borderRadius="standard"
      paddingX="small"
      height="touchable"
      display="flex"
      alignItems="center"
      className={styles.displayUrl}
    >
      <Text
        id="manage-url-txt"
        data={{ automation: 'manage-url-txt' }}
        maxLines={1}
        size="small"
        tone={urlTone}
      >
        <span className={clickable ? styles.link : undefined}>
          {profileDisplayUrl}
        </span>
      </Text>
    </Box>
  );

  return (
    <Stack space="xsmall">
      <Columns space="xsmall" alignY="center">
        <Column>
          <Link
            href={profileUrl}
            target="_blank"
            rel="noopener noreferrer"
            data={{ automation: 'shared-profile-link' }}
          >
            <DisplayUrl clickable />
          </Link>
        </Column>
        <Column width="content">
          <CopyButton variant="buttonIcon" profileUrl={profileUrl} />
        </Column>
      </Columns>
    </Stack>
  );
};
